import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { isAssetToShip } from 'src/app/utils/asset-shipping';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { DeliveryControllerFindOne$Params } from 'src/app/api/fn/delivery/delivery-controller-find-one';
import { DeliveryProduct, DeliveryProductItemEssential } from 'src/app/api/models';
import { DeliveryService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-delivery-products-picker',
  templateUrl: './modal-delivery-products-picker.component.html',
  styleUrls: ['./modal-delivery-products-picker.component.scss'],
})
export class ModalDeliveryProductsPickerComponent {
  @ViewChild('keywordFilter') keywordFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('brandFilter') brandFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('codeSupplierFilter') codeSupplierFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('codeEanFilter') codeEanFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('partNumberFilter') partNumberFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('descShortFilter') descShortFilter?: ElementRef<HTMLInputElement>;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  // question_title: string;
  //   chosenRegistries?: RegistryItem[] = []

  deliveryProductID?: number;
  deliveryID?: number;
  deliveryProducts: DeliveryProduct[] = [];
  loading: boolean = false;
  totalRecords: number = 0;
  selectedDeliveryProducts = [];
  // chosenDeliveryProducts?: DeliveryProduct[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private deliveryService: DeliveryService
  ) {
    this.deliveryProductID = config?.data?.deliveryProductID;
    this.deliveryID = config?.data?.deliveryID;
    // this.question_title = config.data!.question_title;
    this.selectedDeliveryProducts = config.data!.chosenDeliveryProducts;
  }

  ngOnInit() {
    this.loadDeliveryProducts();
  }

  loadDeliveryProducts() {
    this.loading = true;
    const params: DeliveryControllerFindOne$Params = {
      id: this.deliveryID!,
    };
    // if (event.globalFilter != null) {
    //   // keyword
    //   if (event.globalFilter[0] != '') {
    //     params.query = event.globalFilter[0];
    //   }
    //   // altro
    //   if (event.globalFilter[1] != undefined) {
    //     if(event.globalFilter[1]?.length > 0) {
    //       params.contact_types = ((event.globalFilter[1] as unknown) as string[]).map(x => +x);
    //     }
    //   }
    // }

    this.deliveryService.deliveryControllerFindOne(params).subscribe({
      next: res => {
        this.deliveryProducts = res.data.delivery_products
          .flatMap(dp => {
            const serialsToAdd = dp.asset_managements.filter(am => isAssetToShip(am));
            if (serialsToAdd.length === 0) {
              return [];
            }
            return serialsToAdd.map(am => ({
              ...dp,
              am_id: am.id,
              serial_number: {
                code: am.serial_number,
                to_add: false,
                ddt_id: isAssetToShip(am) ? null : am.related_ddt_id,
              },
            }));
          })
          .filter(
            dp => dp.product_id === this.deliveryProductID || dp.serial_number.ddt_id !== null
          );

        this.totalRecords = this.deliveryProducts.length;
        this.loading = false;
      },
    });
    // if(this.chosenRegistries){
    //   this.selectedDeliveryProducts = this.chosenRegistries
    // }
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({
      allDeliveryProducts: this.deliveryProducts,
      selectedDeliveryProducts: this.selectedDeliveryProducts,
      serialized_from_delivery_qty: this.deliveryProducts.length,
    });
  }
  clear(table: Table) {
    table.clear();
    if (this.keywordFilter) {
      this.keywordFilter.nativeElement.value = '';
    }
    if (this.brandFilter) {
      this.brandFilter.nativeElement.value = '';
    }
    if (this.codeSupplierFilter) {
      this.codeSupplierFilter.nativeElement.value = '';
    }
    if (this.codeEanFilter) {
      this.codeEanFilter.nativeElement.value = '';
    }
    if (this.partNumberFilter) {
      this.partNumberFilter.nativeElement.value = '';
    }
    if (this.descShortFilter) {
      this.descShortFilter.nativeElement.value = '';
    }
  }

  // checkIfProdIsChosen(dp: DeliveryProduct) {
  //   if (this.chosenDeliveryProducts) {
  //     return this.chosenDeliveryProducts?.some((cp) => cp.id === dp.id);
  //   }
  //   return false;
  // }
}
